export default{
    isFamilyRelationship : 'نسبت فامیلی دارد؟',
    familyRelationship : 'نسبت',
    maleBloodType: 'گروه خونی آقا',
    femaleBloodType: 'گروه خونی خانم',
    isRealizationOfMarriage: ' احراز زوجیت انجام شده؟',
    totalAgeOfMenAndWomen: ' مجموع سنی آقا و خانم',
    genderDetermination: 'تعیین جنسیت',
    historyOfPresentingComplaint: 'علت مراجعه(CC)',
    durationOfMarriage: 'مدت زمان ازدواج',
    infertility: 'مدت زمان ناباروری',
    allergy: 'حساسیت',
    addiction: 'اعتیاد',
    cycle: 'دوره',
    irregular: 'نامنظم',
    regular: 'منظم',
    menopause: 'یائسگی',
    duration: 'مدت(به روز)',
    interval: 'فاصله',
    pain: 'درد',
    heaviness: 'میزان خونریزی',
    lmp: 'LMP',
    imb: 'IMB',
    pCB: 'PCB',
    contraceptive: 'روشهای پیشگیری از بارداری',
    weight: 'وزن',
    height: 'قد(به سانتیمتر) ',
    bmi: 'BMI',
    low: 'کم',
    average: 'متوسط',
    high: 'زیاد',
    numberOfChildren: 'تعداد فرزند',
    freezer:'فریز',
    delete:'حذف',
    donate: 'اهدا',
    child: 'فرزند',
    dysmenorrhea : 'Dysmenorrhea',
    dyspareunia : 'Dyspareunia',
    dyschezia : 'Dyschezia',
    dysuria : 'Dysuria',
    nonCyclicPain : 'Non-Cyclic Pain',
    cyclicConstipation : 'Cyclic Constipation',
    cyclicDiarrhea : 'Cyclic Diarrhea',
    cyclicSiatalgia : 'Cyclic Siatalgia',
}